<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Lab', apiMethod: 'Labs', form: () => import('../forms/LabForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Lab Test', apiMethod: 'LabTests', parentForeignKey: 'labId', form: () => import('../forms/LabTestForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Tests', value: 'labId', isCard: true, table: () => import('../tables/LabTestsTable') },
                    { text: 'Sample Tests', value: 'labId', table: () => import('../tables/SampleTestsTable') },
                ],
                mainForm: () => import('../forms/LabForm'),
                claimName: 'Labs',
                apiMethod: 'Labs',
            }
        }
    };
</script>
